module.exports = __webpack_public_path__ + "img/logo.5a60e20a.png";